import { connect } from 'react-redux';
import { requestAgency, sendAgentInvite, editAgency, editAgencyImage } from '../modules/agency';

import Agency from '../components/Agency';


const mapDispatchToProps = {
  requestAgency,
  editAgency,
  editAgencyImage,
  sendAgentInvite,
};

const mapStateToProps = state => ({
  isFetching: state.agency.isFetching,
  needFetch: state.agency.needFetch,
  agency: state.agency.selectedAgency,
});

export default connect(mapStateToProps, mapDispatchToProps)(Agency);



// WEBPACK FOOTER //
// src/routes/agency/containers/AgencyContainer.js